import { render, staticRenderFns } from "./runpayroll.vue?vue&type=template&id=2c5ceb66&scoped=true"
import script from "./runpayroll.vue?vue&type=script&lang=js"
export * from "./runpayroll.vue?vue&type=script&lang=js"
import style0 from "./runpayroll.vue?vue&type=style&index=0&id=2c5ceb66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ceb66",
  null
  
)

export default component.exports